import { TRAVEL_KEY } from '@/shared/constants/storage.constants'

export const useLocalStorage = () => {
  // TODO: Implenet
  // getValue(key: string | string[]) => unknown | null
  // setValue(key: string| string[], value: unknown | unknown[]) => void
  // updateValue(key: string | string[], value: unknown | unknown[]) => void
  // removeValue(key: string | string[]) => void
  // clear() => void

  const getRoot = () => localStorage.getItem(TRAVEL_KEY)

  const get = (key: string) => {
    const data = getRoot()
    if (!data) {
      return null
    } else {
      const existingJson = JSON.parse(data)
      return existingJson[key]
    }
  }

  const setOrUpdate = (key: string, value: unknown) => {
    const data = getRoot()
    if (!data) {
      localStorage.setItem(TRAVEL_KEY, JSON.stringify({ [key]: value }))
    } else {
      const json = JSON.parse(data)
      localStorage.setItem(TRAVEL_KEY, JSON.stringify({ ...json, [key]: value }))
    }
  }

  const clear = (key: string) => {
    const data = getRoot()
    if (data) {
      const json = JSON.parse(data)
      localStorage.setItem(TRAVEL_KEY, JSON.stringify({ ...json, [key]: undefined }))
    }
  }

  const clearAll = () => {
    localStorage.removeItem(TRAVEL_KEY)
  }

  return {
    getRoot,
    setOrUpdate,
    get,
    clear,
    clearAll,
  }
}
